import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 0.5rem;
  gap: 1rem;
  width: 100%;
  overflow-y: auto;
  max-height: 28rem;

  .container {
    display: flex;
    width: 95%;
    justify-content: space-between;

    .title {
      color: ${({ theme }) => theme.colors.secondary};
      font-weight: 500;
      margin: 0;
      font-size: 1.5rem;
    }

    p {
      color: ${({ theme }) => theme.colors.text_gray};
      font-weight: 300;
      font-size: 1.2rem;
    }

    .containersolicitationData {
      min-width: 40%;

      .requested-by {
        .icon-buton {
          display: flex;
          align-items: center;

          button {
            display: flex;
            align-items: center;
            background: none;
            margin: 0;
            padding: 0;
            border: 0;

            transition: opacity 0.5s;
            :hover {
              opacity: 0.7;
              cursor: pointer;
            }

            svg {
              color: ${({ theme }) => theme.colors.tertiary_500};
              width: 1.2rem;
              height: 1.2rem;
              margin-left: 0.5rem;
            }
          }
        }
      }
    }
  }

  .containerMoreInformation {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 0.5rem;

    h1 {
      color: ${({ theme }) => theme.colors.secondary};
      font-weight: 500;
      margin: 0;
      font-size: 1.2rem;
    }

    .containerNote {
      display: flex;
      flex-direction: column;
      width: 95%;
      p {
        border: none;
        font-weight: 400;
        color: ${({ theme }) => theme.colors.text_gray};
      }
    }

    .containerAttachments {
      display: flex;
      flex-direction: column;

      .contentAttachments {
        display: grid;
        grid-template-columns: 1fr 1fr;
      }
    }
  }

  @media (max-width: 690px) {
    border-right: none;
    border-bottom: solid 1px ${({ theme }) => theme.colors.gray};
    width: -webkit-fill-available;
    margin-left: 0;
  }

  @media (max-width: 480px) {
    .container {
      flex-direction: column;
      gap: 0.5rem;

      .containersolicitationData {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
      }
    }
  }

  @media (max-width: 350px) {
    .containerMoreInformation .containerAttachments .contentAttachments {
      grid-template-columns: 1fr;
    }
  }
`;
